import { render, staticRenderFns } from "./EditPaxModal.vue?vue&type=template&id=fdf9d3aa&"
import script from "./EditPaxModal.vue?vue&type=script&lang=ts&"
export * from "./EditPaxModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports